var Storage = /** @class */ (function () {
    function Storage() {
    }
    Storage.prototype.get = function (key) {
        return localStorage.getItem(key);
    };
    Storage.prototype.set = function (key, value) {
        return localStorage.setItem(key, value);
    };
    Storage.prototype.remove = function (key) {
        return localStorage.removeItem(key);
    };
    Storage.prototype.getJSON = function (key) {
        return JSON.parse(this.get(key) || 'null');
    };
    Storage.prototype.setJSON = function (key, value) {
        return this.set(key, JSON.stringify(value));
    };
    return Storage;
}());
export default new Storage();



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Storage.ts
// module id = 93
// module chunks = 0